import { Injectable } from '@angular/core';

@Injectable()
export class ValidationService {
  public validateInputs(data: any, requirmentsObject: any): void {
    Object.keys(requirmentsObject).forEach((key) => {
      if (data[key] === undefined || data[key] === '' || data[key] === null) {
        requirmentsObject[key] = false;
      } else {
        requirmentsObject[key] = true;
      }
    });
  }

  public validation(requirmentsObject: object): boolean {
    if (Object.values(requirmentsObject).indexOf(false) > -1) {
      return true;
    }
    return false;
  }

  public changeInput(value: any, name: string, requirmentsObject: any): void {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        requirmentsObject[name] = true;
      } else {
        requirmentsObject[name] = false;
      }
    } else {
      if (value && value !== '') {
        requirmentsObject[name] = true;
      } else {
        requirmentsObject[name] = false;
      }
    }
  }
}
